import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "hospitalizations-table" }
const _hoisted_2 = { class: "d-flex p-2 mt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold my-auto" }, "Hospitalizations/Emergency Department Encounters", -1 /* HOISTED */)
const _hoisted_4 = { class: "table table-responsive-md border border-gray" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Date Range"),
    /*#__PURE__*/_createElementVNode("th", null, "Diagnoses"),
    /*#__PURE__*/_createElementVNode("th", null, "Discharged To"),
    /*#__PURE__*/_createElementVNode("th", null, "Comments"),
    /*#__PURE__*/_createElementVNode("th", null, "ED Encounter"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_6 = { class: "table-loading" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_10 = ["colspan"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "No Hospitalizations to Display", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "table-error"
}
const _hoisted_14 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HospitalAdmissionForm = _resolveComponent("HospitalAdmissionForm")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_HospitalizationsRow = _resolveComponent("HospitalizationsRow")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" FORM "),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            slot: "list-header",
            type: "button",
            class: "btn btn-primary ms-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAddHospitalization()))
          }, " Add Hospitalization/ED Encounter "))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`card px-lg-5 py-2 mb-2 w-100 h-100 animated ${
                _ctx.isAddRequested ? 'faster fadeInDown' : 'slow fadeOutUp'
            }`)
        }, [
          _createVNode(_component_HospitalAdmissionForm, {
            hospitalization: _ctx.newHospitalization,
            "cancel-hospitalization": _ctx.cancelAddHospitalization,
            "save-hospitalization": _ctx.saveHospitalization,
            "is-loading": _ctx.isSaving,
            "is-new": true,
            "provider-id": _ctx.providerId,
            roles: _ctx.roles,
            "patient-info": _ctx.patientInfo,
            application: _ctx.application,
            accountId: _ctx.accountId
          }, null, 8 /* PROPS */, ["hospitalization", "cancel-hospitalization", "save-hospitalization", "is-loading", "provider-id", "roles", "patient-info", "application", "accountId"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" LIST "),
    _createVNode(_component_Pagination, {
      ref: "paginationInstance",
      "page-changed": _ctx.pageChangedCallback,
      "is-loading": _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            _createCommentVNode(" LOADING "),
            (_ctx.isLoading)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                  return (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                      return (_openBlock(), _createElementBlock("td", null, _hoisted_8))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" NO RESULTS "),
            (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_12, 8 /* PROPS */, _hoisted_10)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ERROR "),
            (!_ctx.isLoading && _ctx.isError)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                  _createElementVNode("td", { colspan: _ctx.columns }, [
                    _createVNode(_component_ErrorMessageHandler, {
                      title: "Hospitalizations",
                      "try-again": _ctx.reset
                    }, null, 8 /* PROPS */, ["try-again"])
                  ], 8 /* PROPS */, _hoisted_14)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          (!_ctx.isLoading && !_ctx.isError && _ctx.hasData)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page.Items, (hospitalization, index) => {
                return (_openBlock(), _createBlock(_component_HospitalizationsRow, {
                  hospitalization: hospitalization,
                  columns: _ctx.columns,
                  index: index,
                  "page-reset": _ctx.reset,
                  "patient-id": _ctx.patientId,
                  "provider-id": _ctx.providerId,
                  roles: _ctx.roles,
                  "patient-info": _ctx.patientInfo,
                  accountId: _ctx.accountId,
                  handleCancelEditHospitalization: _ctx.handleCancelEditHospitalization,
                  application: _ctx.application
                }, null, 8 /* PROPS */, ["hospitalization", "columns", "index", "page-reset", "patient-id", "provider-id", "roles", "patient-info", "accountId", "handleCancelEditHospitalization", "application"]))
              }), 256 /* UNKEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page-changed", "is-loading"])
  ]))
}